module.exports = __webpack_public_path__ + "static/media/24.6539a516.jpg";